import { IconProps } from './IconProps';

export const Charger = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="34"
      height="14"
      viewBox="0 0 34 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.8047 3.46719C33.7882 3.29314 33.7073 3.13153 33.5778 3.01413C33.4482 2.89674 33.2795 2.83206 33.1047 2.83281L28.0406 2.83281V0.7C28.0406 0.514354 27.9668 0.336317 27.8355 0.205045C27.7043 0.073774 27.5262 1.85525e-05 27.3406 0L8.64841 0C8.46276 1.85525e-05 8.28472 0.073774 8.15345 0.205045C8.02218 0.336317 7.94843 0.514354 7.94841 0.7V6.3H0.904659C0.811901 6.29869 0.719807 6.31583 0.633728 6.35042C0.547649 6.385 0.469303 6.43636 0.403244 6.50149C0.337189 6.56662 0.284733 6.64423 0.248928 6.72981C0.213127 6.81539 0.194691 6.90723 0.194691 7C0.194691 7.09277 0.213127 7.18461 0.248928 7.27019C0.284733 7.35577 0.337189 7.43338 0.403244 7.49851C0.469303 7.56364 0.547649 7.615 0.633728 7.64959C0.719807 7.68418 0.811901 7.70131 0.904659 7.7H7.94841V13.3C7.94843 13.4856 8.02218 13.6637 8.15345 13.795C8.28472 13.9262 8.46276 14 8.64841 14L27.3406 14C27.5262 14 27.7043 13.9262 27.8355 13.795C27.9668 13.6637 28.0406 13.4856 28.0406 13.3V11.1672H33.1047C33.2903 11.1672 33.4683 11.0934 33.5996 10.9621C33.7309 10.8309 33.8046 10.6528 33.8047 10.4672V3.53281C33.8057 3.51095 33.8057 3.48905 33.8047 3.46719ZM32.4047 4.23281V9.76719H28.0406V4.23281H32.4047ZM26.6406 1.4V12.6L9.34841 12.6V1.4L26.6406 1.4Z"
        fill="black"
      />
    </svg>
  );
};

